import React from 'react';
import { List } from 'semantic-ui-react';
import { map } from 'lodash';
import { useSelector, shallowEqual } from 'react-redux';
import { UniversalLink } from '@plone/volto/components';
import { flattenToAppURL, addAppURL } from '@plone/volto/helpers';

const FooterSmallCenter = () => {
  const { siteActions = [] } = useSelector(
    (state) => ({
      siteActions: state.actions?.actions?.site_actions,
    }),
    shallowEqual,
  );

  return (
    <div className="footer-small-center">
      <List horizontal>
        {siteActions?.length
          ? map(siteActions, (item) => (
              <div role="listitem" className="item" key={item.id}>
                <UniversalLink
                  className="item"
                  href={
                    item.url ? flattenToAppURL(item.url) : addAppURL(item.id)
                  }
                >
                  {item?.title}
                </UniversalLink>
              </div>
            ))
          : null}
      </List>
    </div>
  );
};

export default FooterSmallCenter;
